var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfoExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F39200",
    d: "M1.171 5.013L.313 6.84l1.096 3.31 18.64-5.375-1.331-3.334L16.56.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M20.515 9.688H4.63l15.259-4.45a.467.467 0 0 0 .318-.58l-.799-2.775A2.61 2.61 0 0 0 16.914 0c-.242 0-.483.035-.717.103L1.871 4.28A2.577 2.577 0 0 0 .324 5.529a2.606 2.606 0 0 0-.221 1.983l.78 2.711v11.168A2.603 2.603 0 0 0 3.474 24H9.07c.257 0 .466-.21.466-.469a.467.467 0 0 0-.466-.468H3.474c-.915 0-1.66-.75-1.66-1.672v-6.379H20.05v6.38c0 .92-.745 1.67-1.66 1.67h-5.596a.467.467 0 0 0-.465.47c0 .258.208.468.465.468h5.596a2.603 2.603 0 0 0 2.59-2.609V10.157a.467.467 0 0 0-.465-.47zm-8.21 4.387l1.978-3.45h2.573l-1.978 3.45h-2.573zm-3.649 0l1.978-3.45h2.574l-1.979 3.45H8.656zm-3.648 0l1.978-3.45h2.573l-1.978 3.45H5.008zm1.73-6.069L3.427 4.803l2.482-.724c.018.026.038.05.061.073l3.313 3.203-2.482.724a.466.466 0 0 0-.061-.073zm6.24-5.898l3.313 3.203-2.482.724a.456.456 0 0 0-.061-.073L10.435 2.76l2.482-.724c.018.026.038.05.061.073zM9.474 3.13l3.313 3.203-2.483.724a.456.456 0 0 0-.06-.072L6.93 3.78l2.482-.724c.018.026.039.05.062.073zm6.982-2.127c.15-.043.304-.065.458-.065.737 0 1.394.495 1.599 1.205l.669 2.325-1.868.545a.476.476 0 0 0-.062-.073L13.94 1.737l2.517-.734zM1.14 5.981a1.65 1.65 0 0 1 .99-.8l.273-.08c.018.026.038.05.062.073l3.312 3.203-4.11 1.199-.67-2.325a1.67 1.67 0 0 1 .143-1.27zm.674 4.644H5.91l-1.978 3.45H1.814v-3.45zm14.14 3.45l1.978-3.45h2.118v3.45h-4.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39200",
    fillRule: "nonzero",
    d: "M10.06 20.555v-3.131l2.695 1.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M14.152 18.99a.47.47 0 0 0-.233-.406l-4.091-2.378a.463.463 0 0 0-.466 0 .47.47 0 0 0-.233.406v4.755a.47.47 0 0 0 .466.47c.08 0 .16-.022.233-.064l4.09-2.377a.47.47 0 0 0 .234-.406zm-4.091 1.565v-3.131l2.694 1.566-2.694 1.565zM10.932 23.063a.468.468 0 0 0 0 .937.468.468 0 0 0 0-.938z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoExpert);
export default __webpack_public_path__ + "static/media/ic-info-expert.8bfcc106d62d5969e99a436ee60662bf.svg";
export { ForwardRef as ReactComponent };